import * as yup from 'yup';

const tncSellingConsent = yup.bool()
  .required('tncSellingConsent.required.error')
  .isTrue('tncSellingConsent.isTrue.error');

const bankingTerms = yup.bool()
  .required('bankingTermsn.required.error')
  .isTrue('bankingTerms.isTrue.error');

export {
  tncSellingConsent,
  bankingTerms,
};
